import React from 'react';
import { PushNotifications, DataSets, Overview, Templates, Runner } from 'modules/InstantUpdate';
import { SideBarItems } from 'components/Sidebar';
import {
    SpaceDashboardOutlined,
    DataObjectOutlined,
    TipsAndUpdatesOutlined,
    Groups3Outlined
  } from "@mui/icons-material";
  import RateReviewIcon from '@mui/icons-material/RateReview';
  import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
  import PlayArrowIcon from '@mui/icons-material/PlayArrow';
  
export const ModulesMenu: SideBarItems[] = [{
    path:"/",
    urlKey: "instant-updates",
    text: "Campaigns",
    icon: <Groups3Outlined />,
    type: "menuHeader",
    menuKey: "campaignKing",
    dictionaryKey: "sidebar-menu-instant-updates",
    items: [
      // {
      //   path:"/instant-updates/",
      //   urlKey: "overview",
      //   text: "Overview",
      //   icon: <SpaceDashboardOutlined />,
      //   type: "menuItem",
      //   module: <Overview/>
      // },
      {
        path:"/instant-updates/",
        urlKey: "data-sets",
        text: "Data Sets",
        icon: <DataObjectOutlined />,
        type: "menuItem",
        menuKey: "campaignKing",
        module: <DataSets />,
        dictionaryKey: "sidebar-menu-instant-updates-data-sets",
      },
      {
        path:"/instant-updates/",
        urlKey: "templates",
        text: "Template",
        icon: <RateReviewIcon />,
        type: "menuItem",
        menuKey: "campaignKing",
        module: <Templates />,
        dictionaryKey: "sidebar-menu-instant-updates-templates",
      },
      {
        path:"/instant-updates/",
        urlKey: "runner",
        text: "Runner",
        icon: <PlayArrowIcon />,
        type: "menuItem",
        menuKey: "campaignKing",
        module: <Runner />,
        requiredModule: "instantupdate.ai",
        requiredRole: "user",
        dictionaryKey: "sidebar-menu-instant-updates-runner",
      },
      {
        path:"/instant-updates/",
        urlKey: "push-notifications",
        text: "Push Notifications",
        icon: <ScheduleSendIcon />,
        type: "menuItem",
        menuKey: "campaignKing",
        module: <PushNotifications />,
        requiredModule: "instantupdate.ai",
        requiredRole: "user",
        disabled: true,
        dictionaryKey: "sidebar-menu-instant-updates-push-notifications",
      },
    ]
  },


  {
    path:"/",
    urlKey: "instant-updates",
    text: "Instant Update",
    icon: <Groups3Outlined />,
    type: "menuHeader",
    menuKey: "instantUpdate",
    dictionaryKey: "sidebar-menu-instant-updates",
    items: [
      // {
      //   path:"/instant-updates/",
      //   urlKey: "overview",
      //   text: "Overview",
      //   icon: <SpaceDashboardOutlined />,
      //   type: "menuItem",
      //   module: <Overview/>
      // },
      {
        path:"/instant-updates/",
        urlKey: "data-sets",
        text: "Data Sets",
        icon: <DataObjectOutlined />,
        type: "menuItem",
        menuKey: "instantUpdate",
        module: <DataSets />,
        dictionaryKey: "sidebar-menu-instant-updates-data-sets",
      },
      {
        path:"/instant-updates/",
        urlKey: "templates",
        text: "Template",
        icon: <RateReviewIcon />,
        type: "menuItem",
        menuKey: "instantUpdate",
        module: <Templates />,
        dictionaryKey: "sidebar-menu-instant-updates-templates",
      },
      {
        path:"/instant-updates/",
        urlKey: "runner",
        text: "Scheduler",
        icon: <ScheduleSendIcon />,
        type: "menuItem",
        menuKey: "instantUpdate",
        module: <Runner />,
        requiredModule: "instantupdate.ai",
        requiredRole: "user",
        dictionaryKey: "sidebar-menu-instant-updates-runner",
      },
      {
        path:"/instant-updates/",
        urlKey: "push-notifications",
        text: "Push Notifications",
        icon: <PlayArrowIcon />,
        type: "menuItem",
        menuKey: "instantUpdate",
        module: <PushNotifications />,
        requiredModule: "instantupdate.ai",
        requiredRole: "user",
        disabled: true,
        dictionaryKey: "sidebar-menu-instant-updates-push-notifications",
      },
    ]
  }];